import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path opacity=".4" d="M8 14.667A6.667 6.667 0 108 1.333a6.667 6.667 0 000 13.334z" fill="currentColor" /><path d="M7.222 10.055a.496.496 0 01-.353-.146L5.313 8.353a.5.5 0 01.708-.707l1.202 1.202L9.98 6.09a.5.5 0 11.707.707l-3.11 3.111a.5.5 0 01-.355.146z" fill="currentColor" /></svg>);